import {$} from '../jquery-definition.js';

$( function() {
	$( '.search-toggle' ).on( 'click', function( clickEvent ) {
		if ( $( 'body' ).hasClass( 'active-search' ) ) {
			$( '#header-search' ).focus();
		}
	} );
} );
